import Keycloak from 'keycloak-js';
import apiUrl  from './constants';
let keycloakUrl = apiUrl.keycloakUrl;
let authclientid = apiUrl.authclientid;


const keycloak = new Keycloak({
    url: keycloakUrl,
    realm: 'xpressbees', 
    clientId: authclientid, 
    onLoad: 'login-required'
});

async function getAuthToken() {
    // Check if the token is expired.
    if (keycloak.tokenExpired) {
        // Refresh the token.
        await keycloak.updateToken();
    }
    // Return the token.
    return keycloak.token;
}

/**
 * This function will redirect the user on confirm logout screen
 */

keycloak.logoutWithoutTokenId = async () => {
    try {
        // localStorage.removeItem('permissiondata')
        // localStorage.removeItem('userdetail')
        // localStorage.removeItem('userToken')
        // localStorage.removeItem('isLoggedIn')
        // localStorage.removeItem('cargoAutoaccesspermissiondata')
        // localStorage.removeItem('cargoAutoaccessuserdata')
        // console.log(keycloak.isTokenExpired())
        // console.log(keycloak.onTokenExpired())
        // let r1 = await keycloak.updateToken()
        keycloak.clearToken()
        await keycloak.logout({ redirectUri: `${apiUrl.app_url}` })

        // window.location.href = "https://stage-auth.xbees.in/realms/xpressbees/protocol/openid-connect/logout?client_id=b2bxpress-ui"
        // window.location.href = "https://stage-auth.xbees.in/realms/xpressbees/protocol/openid-connect/logout?client_id=lastmile-ui&post_logout_redirect_uri=https%3A%2F%2Flastmileallocationpod-appstage.xbees.in%2F";
    } catch (error) {
        console.log(error)
    }
}
keycloak.checktoken = async () => {
    try {
        let result = await keycloak.isTokenExpired()
        return result
    } catch (err) {
        console.log(err)
        return true;
    }
}
keycloak.updaterefreshtoken = async () => {
    try {
        console.log("keycloack.js ==>")
        await keycloak.updateToken(5).then(function(refreshed) {
           if (refreshed) {
            console.log("keycloack.js ==>",refreshed)
             console.log('Token was successfully refreshed');
             window.location.replace(`${apiUrl.app_url}`);
        } else {
             console.log('Token is still valid');
             window.location.replace(`${apiUrl.app_url}${window.location.hash}`);             
           }
         }).catch(function() {
           console.log('Failed to refresh the token, or the session has expired');
           localStorage.removeItem('permissiondata')
            localStorage.removeItem('userdetail')
            localStorage.removeItem('userToken')
            localStorage.setItem('removedtoken6', 'keycloack.updaterefreshtoken.catch')
            localStorage.removeItem('isLoggedIn')
            localStorage.removeItem('cargoAutoaccesspermissiondata')
            localStorage.removeItem('cargoAutoaccessuserdata')
            window.location.replace(`${apiUrl.app_url}`);
         });
        return true
    } catch (err) {
        console.log(err)
        return true;
    }
}



export default keycloak;


// WEBPACK FOOTER //
// ./src/keycloack.js